const LINK_BUTTON_TYPE = "wix-draft-plugin-link-button";
const ACTION_BUTTON_TYPE = "wix-draft-plugin-action-button";
export {
  ACTION_BUTTON_TYPE,
  LINK_BUTTON_TYPE
};
//# sourceMappingURL=types.js.map
